<template>
  <div>
    <section id="headerbar">
      <button
        class="btn btn-collapse"
        id="sidebarCollapse"
        v-on:click="toggle"
      ><i class="lnr lnr-menu"></i></button>
      <div class="dropdown box-lang">
        <b-dropdown
          variant="link"
          size="lg"
        >
          <template slot="button-content">
            {{$t('header.lblLanguage')}}
          </template>
          <b-dropdown-item
            @click="changeLanguage('en')"
            href="#"
          >{{$t('header.lblEnglish')}}</b-dropdown-item>
          <b-dropdown-item
            @click="changeLanguage('mr')"
            href="#"
          >{{$t('header.lblMarathi')}}</b-dropdown-item>
          <b-dropdown-item
            @click="changeLanguage('hi')"
            href="#"
          >{{$t('header.lblHindi')}}</b-dropdown-item>
        </b-dropdown>

      </div>
      <form class="form-search">
        <!-- <div class="form-group">
                        <label class="sr-only">Search</label>
                        <input type="text" class="form-control" id="exampleIn" placeholder="Search...">
                        <i class="lnr lnr-magnifier"></i>
                    </div> -->
      </form>
      <div class="box-profile-mini">
        <b-dropdown
          variant="link"
          size="lg"
        >
          <template slot="button-content">
            <div class="profile-img">
              <!-- <span v-if="uniLogo">
                <img :src="uniLogo" alt="">
              </span> -->
              <span>
                <img
                  src="assets/images/user.png"
                  alt=""
                >
              </span>

            </div>
            <div class="profile-details">
              <div class="pname">{{(universityData.uniAbbr)}} </div>
              <!--  <div class="ptext">{{$t('header.lblUniversityLocation')}}</div> -->
            </div>

          </template>
          <!-- <b-dropdown-item @click="redirectToResetPassword()">Reset Password</b-dropdown-item> -->
          <!--  <b-dropdown-item href="#">{{$t('header.lblEditProfile')}}</b-dropdown-item>
    -->
          <!--  <b-dropdown-item @click="logout">{{$t('header.lblLogOut')}}</b-dropdown-item>
  -->
        </b-dropdown>

      </div>
      <div class="box-icons">
        <!-- <a href="#"><i class="lnr lnr-alarm"></i></a>
                    <a href="#"><i class="lnr lnr-envelope"></i></a> -->
        <a @click="logout"><i class="lnr lnr-power-switch"></i></a>
      </div>
    </section>

  </div>
</template>
<script>
import MQL from "@/plugins/mql.js";
// import axios from 'axios'
// import lodashOrderBy from 'lodash/orderBy'
export default {
  name: 'header1',
  data() {
    return {
      isActive: false,
      isOpen: false,
      isOpen2: false,
      uniLogo: '',
      universityData: {},
      ipDetails: {},
      candidateProfile: {}
    }
  },
  created() {
    if (sessionStorage.getItem('user-token') === null || sessionStorage.getItem('user-token') === "" || sessionStorage.getItem('user-token') === undefined) {
      this.$router.push("login")
    }
    // this.GetIpDetails()
    this.GetProjectConfigService()
  },
  methods: {
    redirectToResetPassword() {
      this.$router.push({ "name": "resetPassword" })
    },
    changeLanguage(lang) {
      this.$i18n.locale = lang
      this.loadMessagesFromFile()
    },
    loadMessagesFromFile() {
      return new Promise((resolve, reject) => {
        return import(`@/lang/${this.$i18n.locale}.json`).then(res => {
          this.$i18n.setLocaleMessage(this.$i18n.locale, res.default)
          resolve(true)
        })
      })
    },
    logout() {
      /* let vm = this;
      window.MKCLAPI.logout()
        .then(() => {
          vm.$store.dispatch("clearStore");
          vm.$router.push("/");
        })
        .catch(e => {
          vm.$toasted.error(vm.$t("logOut.failToLogout"));
        }); */
      this.$store
        .dispatch('AUTH_LOGOUT', {
          // loginType: "mfs_ip"
        })
        .then(res => { })
        .catch(err => {
          alert(err)
          Vue.$log.error(err)
        })
    },
    toggle: function () {
      var element = document.getElementById('left-sidebar')
      element.classList.toggle('active')
      var element2 = document.getElementById('main-content')
      element2.classList.toggle('active')

      // alert("fds");
      // `this` inside methods points to the Vue instance
      // var element = document.getElementById('nav1')
      // var element2 = document.getElementById('toggle-btn')
      // element.classList.toggle('shrinked')
      // `event` is the native DOM event
    },

    toggle2: function () {
      this.isOpen2 = !this.isOpen2
    },
    search: function () {
      this.isActive = true
    },
    searchclose: function () {
      this.isActive = false
    },

    GetIpDetails() {
      this.$MQLFetch('r.GetIpDetailsService')
        .then(response => {
          var res = JSON.parse(JSON.stringify(response.result))
          this.ipDetails = res
        })
        .catch(err => {
          console.log(err)
        })
    },
    GetProjectConfigService() {

      let vm = this;
      new MQL()
        .setActivity("o.[GetProjectConfigService]")
        .fetch()
        .then(rs => {
          let res = rs.getActivity("GetProjectConfigService", true);
          // this.portalUrls = .otherPortalUrls; //res.projectConfig.otherPortalUrls
          this.universityData = res.result.universityDetails
          this.displayLogo()
          if (rs.isValid("GetProjectConfigService")) {
          } else {
            rs.showErrorToast("GetProjectConfigService");
          }
        });
      // this.$MQLFetch('o.GetProjectConfigService')
      //   .then(response => {
      //     var res = JSON.parse(JSON.stringify(response.result))

      //     this.universityData = res.projectConfig.universityDetails

      //     this.displayLogo()
      //   })
      //   .catch(err => {
      //     this.$toasted.error('Something Went Wrong')
      //     //  console.log(err)
      //   })
    },
    displayLogo() {
      this.uniLogo = 'assets/images/' + this.universityData.uniAbbr + '.png'
    }
  }
}
</script>

<style scoped>
</style>
